import React from 'react'

import { GetServerSidePropsContext } from 'next'
import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'

import { Text } from '@/components/Text'
import { PageLayout } from '@/components/Layout/PageLayout'
import { Path } from '@/components/Path'

import { ColorsMap } from '@/utils/Theme'

import { getSettings } from '@/redux/actions'
import { initializeStore } from '@/redux/store'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 14%;
  margin-bottom: 4rem;
`
const Logo = styled.div`
  margin: 3rem auto;
`
const MapWrapper = styled.div`
  margin: 0 auto;

  > * {
    width: 40rem;
    height: 35rem;
  }
`

const AboutUs = ({ state }) => {
  const { t } = useTranslation('common')

  return (
    <PageLayout title={`${t('title:about-us')} | ${state.settings.name}`}>
      <Path pathLinks={[<span>{t('about-us')}</span>]} />
      <Wrapper>
        <Text fontSize="xl" textColor={ColorsMap.primary} fontWeight="bold" m="1rem auto">
          {t('about-us-title')}
        </Text>
        <Text m="0.5rem">{t('about-us-brand')}</Text>
        <Text m="0.5rem">{t('about-us-history')}</Text>
        <Text m="0.5rem">{t('about-us-about')}</Text>
        <Text m="0.5rem">{t('about-us-text-1')}</Text>
        <Text m="0.5rem">{t('about-us-text-contact')}</Text>
        <Logo>
          <Image src="/images/logo.svg" alt="Sintra Šport logo" width={250} height={50} />
        </Logo>
        <MapWrapper>
          <iframe
            src="https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1s48.888561107333445,+18.010037487324023!6i15"
            frameBorder="0"
            title="Sintra Šport"
          />
        </MapWrapper>
      </Wrapper>
    </PageLayout>
  )
}

const mapStateToProps = (state: { state: object }) => ({
  state,
})

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(AboutUs)

